<template>
  <QS-login
    :loading="loading"
    :count-number="countNumber"
    :passwordLength="6"
    :system-name="SystemName"
    @handleSendMsg="handleSendMsg"
    @handleLogin="handleLogin"/>
</template>

<script>
import request from '@/utils/request'
import { SystemName, interfacePrefix } from '@/config'
import { debounce } from '@/utils'
import md5 from 'blueimp-md5'

let tid = null

export default {
  name: 'Login',
  data() {
    return {
      SystemName,
      countNumber: 0,
      loginForm: {
        username: '',
        password: '',
        captcha: '',
      },
      loading: false,
      redirect: '',
    }
  },
  watch: {
    $route: {
      handler(route) {
        this.redirect = route.query && route.query.redirect
      },
      immediate: true,
    },
  },
  methods: {
    handleSendMsg(val) {
      this.loginForm = val
      const { username } = val
      if (username) {
        if (tid) {
          clearInterval(tid)
        }
        this.countNumber = 60
        request({
          url: `${interfacePrefix}/user/token/sendSms`,
          method: 'post',
          data: {
            username: this.loginForm.username.trim(),
          },
        }).then(() => {
          tid = setInterval(() => {
            if (this.countNumber <= 0 && tid) {
              clearInterval(tid)
            }
            this.countNumber--
          }, 1000)
        }).catch(() => {
          if (tid) {
            clearInterval(tid)
          }
          this.countNumber = 0
        })
      }
    },
    handleLogin(val) {
      this.loginForm = val
      const { username, captcha } = val
      if (username && captcha) {
        debounce(this.requestLogin(), 500)
      }
    },
    requestLogin() {
      this.loading = true
      this.$store.dispatch('Login', this.loginForm).then(() => {
        this.loading = false
        // 登录成功后重新加载资源，带上租户信息，用于Nginx判断是否根据配置走灰度发布策略
        window.location.reload(true)
        this.$_showMessageAlert() // 登录成功时，显示右下角弹窗
        this.$_showMessageMustRead() // 登录成功时，显示中间弹窗
      }).catch(() => {
        this.loading = false
        // this.$message.error(err.msg)
      })
    },
  },
}
</script>

<style scoped>
.login-container{
  background: #212f40 url('~@/assets/img/bg_login_chewu.png') no-repeat;
  background-size: cover;
}
</style>
